export const ncmPattern = /^\d+(\.\d+)*$/;
